(function () {
  const DEFAULT_SUBMIT_URL = 'https://shopify.dand3.com/hok/welcome/signup';
  const successKey = 'hokWelcomeSignupCompletedUntil';
  const successDays = 90;

  const countryCodes = [
    ['🇸🇬', '+65'], ['🇲🇾', '+60'], ['🇮🇩', '+62'], ['🇵🇭', '+63'], ['🇹🇭', '+66'], ['🇻🇳', '+84'],
    ['🇧🇳', '+673'], ['🇰🇭', '+855'], ['🇱🇦', '+856'], ['🇲🇲', '+95'], ['🇭🇰', '+852'], ['🇲🇴', '+853'],
    ['🇹🇼', '+886'], ['🇨🇳', '+86'], ['🇯🇵', '+81'], ['🇰🇷', '+82'], ['🇮🇳', '+91'], ['🇧🇩', '+880'],
    ['🇵🇰', '+92'], ['🇱🇰', '+94'], ['🇳🇵', '+977'], ['🇲🇻', '+960'], ['🇦🇺', '+61'], ['🇳🇿', '+64'],
    ['🇺🇸', '+1'], ['🇨🇦', '+1'], ['🇬🇧', '+44'], ['🇮🇪', '+353'], ['🇫🇷', '+33'], ['🇩🇪', '+49'],
    ['🇮🇹', '+39'], ['🇪🇸', '+34'], ['🇵🇹', '+351'], ['🇳🇱', '+31'], ['🇧🇪', '+32'], ['🇱🇺', '+352'],
    ['🇨🇭', '+41'], ['🇦🇹', '+43'], ['🇩🇰', '+45'], ['🇸🇪', '+46'], ['🇳🇴', '+47'], ['🇫🇮', '+358'],
    ['🇮🇸', '+354'], ['🇬🇷', '+30'], ['🇵🇱', '+48'], ['🇨🇿', '+420'], ['🇸🇰', '+421'], ['🇭🇺', '+36'],
    ['🇷🇴', '+40'], ['🇧🇬', '+359'], ['🇭🇷', '+385'], ['🇸🇮', '+386'], ['🇪🇪', '+372'], ['🇱🇻', '+371'],
    ['🇱🇹', '+370'], ['🇺🇦', '+380'], ['🇹🇷', '+90'], ['🇮🇱', '+972'], ['🇦🇪', '+971'], ['🇸🇦', '+966'],
    ['🇶🇦', '+974'], ['🇰🇼', '+965'], ['🇧🇭', '+973'], ['🇴🇲', '+968'], ['🇿🇦', '+27'], ['🇪🇬', '+20'],
    ['🇲🇦', '+212'], ['🇹🇳', '+216'], ['🇰🇪', '+254'], ['🇳🇬', '+234'], ['🇬🇭', '+233'], ['🇲🇺', '+230'],
    ['🇧🇷', '+55'], ['🇲🇽', '+52'], ['🇦🇷', '+54'], ['🇨🇱', '+56'], ['🇨🇴', '+57'], ['🇵🇪', '+51'],
    ['🇺🇾', '+598'], ['🇯🇲', '+1-876'], ['🇦🇬', '+1-268'], ['🇧🇸', '+1-242'], ['🇧🇧', '+1-246'], ['🇹🇏', '+1-868'],
  ];

  function now() {
    return Date.now();
  }

  function daysFromNow(days) {
    return String(now() + days * 24 * 60 * 60 * 1000);
  }

  function storedUntil(key) {
    const value = Number(localStorage.getItem(key) || 0);
    return Number.isFinite(value) ? value : 0;
  }

  function isTestMode() {
    return new URLSearchParams(window.location.search).get('welcome_test') === '1';
  }

  function formatSignupMessage(payload) {
    if (payload.message) return payload.message;
    if (Array.isArray(payload.errors) && payload.errors.length) return payload.errors.join(' ');
    if (payload.error) return String(payload.error);
    return payload.ok ? 'You are in. Check your inbox soon.' : 'Something went wrong. Please try again.';
  }

  function populateCountrySelect(select) {
    if (!select || select.options.length) return;
    for (const [flag, code] of countryCodes) {
      const option = document.createElement('option');
      option.value = code;
      option.textContent = `${flag} ${code}`;
      if (code === '+65') option.selected = true;
      select.append(option);
    }
  }

  function hasCompletedSignup() {
    if (isTestMode()) return false;
    return storedUntil(successKey) > now();
  }

  function markCompletedSignup() {
    localStorage.setItem(successKey, daysFromNow(successDays));
    document.dispatchEvent(new CustomEvent('hok-welcome-signup:success'));
  }

  function scopeForForm(form) {
    return form.closest('[data-hok-welcome-signup]') || form.closest('[data-hok-welcome-page]');
  }

  function bindWelcomeForm(form) {
    const scope = scopeForForm(form);
    const submitUrl = scope?.dataset?.submitUrl || DEFAULT_SUBMIT_URL;
    const message = scope?.querySelector('[data-hok-welcome-message]');

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      const data = Object.fromEntries(new FormData(form).entries());
      data.consentAccepted = data.consentAccepted === 'on';
      data.sourceUrl = window.location.href;
      if (message) message.hidden = true;
      if (button) button.disabled = true;

      try {
        const response = await fetch(submitUrl, {
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify(data),
        });
        const payload = await response.json();
        const ok = Boolean(payload.ok);
        if (message) {
          message.textContent = formatSignupMessage(payload);
          message.dataset.status = payload.status || (ok ? 'subscribed' : 'failed');
          message.hidden = false;
        }
        if (ok) {
          markCompletedSignup();
          form.reset();
          scope?.querySelectorAll('[data-hok-welcome-country]').forEach(populateCountrySelect);
        }
      } catch (_error) {
        if (message) {
          message.textContent = 'Something went wrong. Please try again.';
          message.dataset.status = 'failed';
          message.hidden = false;
        }
      } finally {
        if (button) button.disabled = false;
      }
    });
  }

  window.HoKWelcomeSignupCore = {
    countryCodes,
    formatSignupMessage,
    populateCountrySelect,
    hasCompletedSignup,
    markCompletedSignup,
    isTestMode,
    successKey,
  };

  document.querySelectorAll('[data-hok-welcome-country]').forEach(populateCountrySelect);
  document.querySelectorAll('[data-hok-welcome-form]').forEach(bindWelcomeForm);
})();
